// extracted by mini-css-extract-plugin
export default {"paginationContainer":"styles_paginationContainer__ZIBUI","seperator":"styles_seperator__wBREX","button":"styles_button__glQNH","current":"styles_current__URBYQ"};